import ScaleLineControl from 'ol/control/ScaleLine';
import * as $ from 'jquery';

const patch_map = [
    ['μm', '微米'],
    ['mm', '毫米'],
    ['km', '公里'],
    ['in', '英寸'],
    ['ft', '英尺'],
    ['mi', '英里'],
    ['nm', '海里'],
    ['m', '米'],
];

export default class ScaleLine extends ScaleLineControl {
    constructor(opt_options) {
        super(opt_options);
        setTimeout(() => this.fix());
    }

    fix() {
        this.dom = $('.ol-scale-line-inner');
        this.dom.on('DOMNodeInserted', () => this.replaceScaleLineUnit());
        this.replaceScaleLineUnit();
    }

    replaceScaleLineUnit() {
        if (this.dom) {
            let text = this.dom.text();
            let replacement = text;
            for (let item of patch_map) {
                replacement = replacement.replace(item[0], item[1]);
            }
            if (text !== replacement) {
                this.dom.text(replacement);
            }
        }
    }
}
